<template>
  <div class="text-small">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col cols="12">
        <div style="margin-bottom: 2px;">
          <em class="cita_svg iconAgendaDetalle"></em>
          <strong style="color:rgb(19 71 103);font-size: 17px;"> Enviar a lista de espera </strong>
        </div>
      </b-col>
    </b-row>


  <b-row>
  <CardPacienteAgenda
      v-if="hayPaciente"
      :datosDetalle="datosDetalle"
      :origen="2"
  ></CardPacienteAgenda>

    <b-col cols="3" v-if="!hayPaciente">
      <br>
      <br>
    <b-card class="borde-azul-simple pb-0">
      <div class="d-flex justify-content-center" style="margin-top: -10px;">
        <img alt="lista de Espera" style="margin-left: 2%;"  width="125px" src="../../assets/paciente/paciente3.png" />
      </div>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
    </b-card>
    </b-col>

    <b-col cols="9">
      <br>

      <div class="mt-2">
        <strong style="color:#0069aa"> Información para enviar a espera </strong>
      </div>


      <br>

      <b-row>
        <b-col>
          <strong> Fecha inicio solicitada <validacion/> </strong>
          <b-form-group>
            <b-form-datepicker
                id="fechacita-datepicker"
                labelNoDateSelected="Fecha inicio de cita solicitada"
                v-model="datosFormulario.fechaInicio"
                range
                class="mb-2"
                :min="fechaMinima"
                in
                no-flip
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col>
          <strong> Fecha fin solicitada <validacion/></strong>
          <b-form-group>
            <b-form-datepicker
                id="fechacitafin-datepicker"
                labelNoDateSelected="Fecha fin de cita Solicitada"
                v-model="datosFormulario.fechaFin"
                range
                class="mb-2"
                :min="fechaMinima"
                in
                no-flip
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <br>

      <b-row>
        <b-col>
          <strong> Días de exclusión <validacion/> </strong>
          <v-select
              style="width: 60%"
              name="dia"
              placeholder="--Seleccionar--"
              label="descripcion"
              multiple
              :options="listaDias"
              :reduce="(variable) => variable.id"
              v-model="datosFormulario.dias">
            <span slot="no-options">No hay dias disponibles</span>
          </v-select>

        </b-col>
      </b-row>

      <br>
      <br>

      <b-row>
        <b-col>
        <strong> Hora inicio <validacion/> </strong>
          <b-form-group>
            <vue-timepicker
                id="idHoraInicio"
                v-model="datosFormulario.horaInicio"
                hide-disabled-items
                format="HH:mm"
                :minute-interval="15"
                :hour-range="rangoHoraForm"
                hide-clear-button
            ></vue-timepicker>
          </b-form-group>
        </b-col>
        <b-col>
          <strong> Hora fin <validacion/> </strong>
          <b-form-group>
            <vue-timepicker
                id="idHoraFin"
                v-model="datosFormulario.horaFin"
                hide-disabled-items
                format="HH:mm"
                :minute-interval="15"
                :hour-range="rangoHoraForm"
                hide-clear-button
            ></vue-timepicker>

          </b-form-group>
        </b-col>
      </b-row>


      <div>
        <b-col
            cols="12"
            v-if="!rangoHoraFormEsValido"
        >
          <validacion texto="Selecciona un horario válido"/>
        </b-col>
      </div>


      <br>

      <b-row>
        <b-col>
          <strong> Observaciones </strong>
          <b-form-group>
            <b-form-textarea
                id="idObservaciones"
                v-model="datosFormulario.comentario"
                placeholder="Introduce tus observaciones"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="mt-2 col-12 d-flex justify-content-center">
        <div class="d-flex justify-content-center"  v-if="datosDetalle.esPacienteVIP">
          <em class="mr-2"  v-b-tooltip.hover.top.v-light
              title="Este Paciente es MISD"
              aria-label="Paciente MISD">
            <font-awesome-icon :icon="['fas', 'crown']" size="md" style="color: #FFD43B;" />
          </em>
          <span>EL PACIENTE AL QUE SE LE ASIGNARÁ LA CITA ES MISD</span>
        </div>

      </div>

      <div class="mt-2 d-flex justify-content-center" style="position: relative; text-align: -webkit-center;">
            <b-button variant="primary" pill @click="llenarDatosListaEspera()">Enviar a lista de espera</b-button>
<!--            <spinner size="small">
              Cargando...
            </spinner>-->
      </div>

    </b-col>
  </b-row>
  </div>
</template>

<script>
import CardPacienteAgenda from "@/components/NuevaAgenda/CardPacienteAgenda";
export default {
  name: "EnviarAListaDeEspera",
  components: {CardPacienteAgenda},
  props:{
    datosDetalle: null,
    hayPaciente: Boolean,
    listaDias: Array,
    datosFormulario: Object,
    fechaMinima: null,
    rangoHoraForm: null,
    rangoHoraClinica: null,
    rangoHoraFormEsValido: null,
  },
  data:()=> ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  computed:{
  },
  methods:{
    llenarDatosListaEspera(){
      let indice = this.datosFormulario.idEspecialidad.indexOf(",");
      let especialidad = indice !== -1 ? this.datosFormulario.idEspecialidad.substring(0, indice) : this.datosFormulario.idEspecialidad ;

      let datos = {
        idMotivoEspera: this.datosFormulario.idMotivoEspera,
        idPaciente: this.datosFormulario.idPaciente,
        comentario: this.datosFormulario.comentario,
        fechaFin: new Date(this.datosFormulario.fechaFin),
        fechaInicio: new Date(this.datosFormulario.fechaInicio),
        horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
        horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
        idEstatusListaEspera: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEmpleado:this.datosDetalle.idDoctor,
        idEspecialidad: especialidad,
        idTratamiento: this.datosFormulario.idTratamiento,
        diasExclusion: this.datosFormulario.dias,
        procesoManual: true,
        idTagMotivoCita: this.datosDetalle.idTagMotivoCita,
        idCita: this.datosDetalle.idCita
      };
      this.$emit('guardarListaEsperaDatos', datos, false)
      //this.$emit('llenarDatosListaEspera', true);
    }
  }
}
</script>

<style scoped>
.iconAgendaDetalle{
  width: 3%;
  margin-bottom: -4px;
  filter: invert(33%) sepia(36%) saturate(825%) hue-rotate(154deg) brightness(86%) contrast(105%);
}
</style>
